import nexus from '@db2b/nexus-js'

const state = {
  all: []
}

const getters = {
  all: state => state.all
}

const actions = {
  load ({commit, state}) {
    return nexus.get('callcenter', '/call_types')
      .then(response => {
        state.all = response.data.data
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/modules/callcenter/call_types.js